import { Stack } from '@fluentui/react';

import InfoSection from './InfoSection';
import OtherSection from './OtherSection';
import ShipmentSection from './ShipmentSection';
import { FormContentBox } from './utils';

export default ({ horizontal }: { horizontal?: boolean }) => {
  return (
    <Stack horizontal={horizontal} tokens={{ childrenGap: 15 }} wrap>
      <FormContentBox title="Satış Bilgileri">
        <InfoSection horizontal={!horizontal} />
      </FormContentBox>
      <FormContentBox title="Teslimat Bilgileri">
        <ShipmentSection />
      </FormContentBox>
      <FormContentBox title="Diğer Bilgiler">
        <OtherSection />
      </FormContentBox>
    </Stack>
  );
};

const tokens = { childrenGap: 5 };
